import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '序号',
      prop: 'index'
    },
    {
      label: '参赛俱乐部',
      prop: 'clubName'
    },
    {
      label: '队员姓名',
      prop: 'name'
    },
    {
      label: '证件号码',
      prop: 'idCard'
    },
    {
      label: '队员账号',
      prop: 'mobile'
    },
    {
      label: '性别',
      prop: 'gender'
    },
    {
      label: '年龄',
      prop: 'age'
    },
    {
      label: '级别',
      prop: 'level'
    },
    {
      label: '身份属性',
      prop: 'identityProperties'
    },
    {
      label: '人员来源',
      prop: 'personnelSource'
    },
  ]
}
